import { useState } from "react";
import { UI } from "../data/content";

const KEY = "kairos_consent";
export const getConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

export const CookieConsent = () => {
  const [done, setDone] = useState(() => !!getConsent());
  const [manage, setManage] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: false, marketing: false });
  const C = UI.cookies;
  if (done) return null;
  const save = (analytics, marketing) => {
    localStorage.setItem(KEY, JSON.stringify({
      essential: true, analytics, marketing,
      ts: new Date().toISOString(), sourceUrl: window.location.href,
    }));
    setDone(true);
  };
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-paper border-t-2 border-[var(--accent)] shadow-[0_-8px_24px_rgba(0,0,0,0.12)]" role="dialog" aria-label={C.title} data-testid="cookie-banner">
      <div className="k-container py-5">
        <p className="font-semibold text-sm mb-1">{C.title}</p>
        <p className="text-xs text-ink-muted max-w-3xl mb-4">{C.body} <a href="/privacy" className="text-brand underline" data-testid="cookie-privacy-link">{C.privacy}</a></p>
        {manage && (
          <div className="flex flex-wrap gap-6 mb-4 text-sm" data-testid="cookie-preferences">
            <label className="flex items-center gap-2 text-ink-muted"><input type="checkbox" checked disabled /> {C.essential}</label>
            <label className="flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={prefs.analytics} onChange={(e) => setPrefs({ ...prefs, analytics: e.target.checked })} data-testid="cookie-analytics-checkbox" /> {C.analytics}</label>
            <label className="flex items-center gap-2 cursor-pointer"><input type="checkbox" checked={prefs.marketing} onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })} data-testid="cookie-marketing-checkbox" /> {C.marketing}</label>
          </div>
        )}
        <div className="flex flex-wrap gap-3">
          <button onClick={() => save(false, false)} className="btn-secondary !py-2 !px-4 text-xs" data-testid="cookie-reject-btn">{C.reject}</button>
          {manage ? (
            <button onClick={() => save(prefs.analytics, prefs.marketing)} className="btn-primary !py-2 !px-4 text-xs" data-testid="cookie-save-btn">{C.save}</button>
          ) : (
            <>
              <button onClick={() => setManage(true)} className="btn-secondary !py-2 !px-4 text-xs" data-testid="cookie-manage-btn">{C.manage}</button>
              <button onClick={() => save(true, true)} className="btn-primary !py-2 !px-4 text-xs" data-testid="cookie-accept-btn">{C.accept}</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
